<template lang="pug">
  div
    v-row.header-styles
      v-col(cols="6")
        div.card-info
          p
            b {{ $t('simplifiedEditing.id') }}: {{' '}}
            span {{ selectedSnapshot.id }}
          p
            b {{ $t('commonWords.description') }}: {{' '}}
            span {{ selectedSnapshot.description }}
        v-chip(
          small
          :color="getChipColor"
          dark
          label
        )
          v-icon(small dark).mr-3 mdi-pencil
          span {{ mode === 'edit' ? $t('simplifiedEditing.editingMode') : $t('simplifiedEditing.viewMode') }}
      v-col(cols="6")
        v-row(v-if="mode === 'edit'").header-rows.button-rows
          v-btn(color="#9C27B0" @click="showModal = true")
            v-icon(size="16px") close
            span {{$t("simplifiedEditing.leaveEditor")}}
          v-btn(:color="hasChanges ? '#31A44C': '#A8A8A8'" :disabled="!hasChanges || viewingMode || !allowedToPublish"
            @click="publishSnapshot()")
            PublishIcon.icon-size
            span {{$t("snapshots.publish")}}
        v-row(v-else).header-rows.button-rows
          v-btn(color="#009CDE" @click="goTo('/selecionar-versao-workspace')")
            v-icon(size="16px") close
            span {{$t("simplifiedEditing.leaveViewer")}}
        v-row.header-rows
          DateInterval(
            v-model='dateInterval'
            @update='updateFilter($event)'
          )
    DataProvider(id="dataTable" ref='dataProvider' :endpoint="mountUrlAndParamsFilter().url"
      :filter="mountUrlAndParamsFilter().filter")
      div(slot-scope='{ data: response, error, loading }')
        DataTable.datatable(
          v-if='response && response.data'
          :data='response && response.data'
          ref='dataTable'
          :title='$t("simplifiedEditing.title")'
          :customTotal='(response && response.total) || 0'
          @pagination='handlePagination'
          :currentSort.sync='filter.orderBy',
          :currentSortOrder.sync='filter.order',
          :selectable='false'
          customHeader=true
          exclude-top-pagination=true
          customIcon="mdi-playlist-edit"
          :loading='loading'
          :buttonHeaders = "false"
          :endpoint='mountUrlAndParamsFilter().url'
          :filter='mountUrlAndParamsFilter().filter'
          :labels='labels'
          :formatLabelFunction='formatLabels'
          :fileName="$t('chatTable.fileName')"
          orientationPDF="landscape"
          :perPage=50
          :createHeader='createHeaderPDF')
          template(slot="custom-filter" )
            v-text-field(
              style='float: right; width: 333px; margin-top: 22px; margin-right: 5px;'
              :placeholder="$t('simplifiedEditing.searchLabel')",
              hide-details
              height="50px"
              filled
              dense
              background-color='#F9F9F9'
              :value='searchQuery'
              @input='handleSearch'
            ).search-input
          template(slot='cells'  slot-scope='{ item }')
            md-table-cell(:md-label='labels[0]' v-html="formatLabels(item, 0)")
            md-table-cell(:md-label='labels[1]' v-html="formatLabels(item, 1)")
            md-table-cell.breakText(:md-label='labels[2]' v-html="formatLabels(item, 2)")
            md-table-cell.breakText(:md-label='labels[3]' v-html="formatLabels(item, 3)")
            md-table-cell.breakText(:md-label='labels[4]' v-html="formatLabels(item, 4)")
            md-table-cell(:md-label='labels[5]' v-html="formatLabels(item, 5)")
            md-table-cell(:md-label='labels[6]')
              v-btn(color='#009CDE' depressed dark fab x-small @click='handleActions(item, "visualize")').mr-3
                v-icon(dark) visibility
              v-btn(color='#31A44C' depressed dark fab x-small @click='handleActions(item, "edit")' v-if='mode === "edit"' ).mr-3
                v-icon(dark) edit
              v-btn(color='#BB2658' depressed fab x-small @click='handleActions(item, "history")' :disabled='hasHistory(item)'
                style="color: #FFFFFF;!important")
                v-icon history
          template(slot='footer' slot-scope='{ pagination }')
            v-row(style='justify-content: flex-end;')
              v-col(cols='auto')
                md-field
                  label(for='pages') {{ $t('assistantsList.perPage') }}
                  md-select(v-model='pagination.perPage' name='pages' )
                    md-option(
                      v-for='item in pagination.perPageOptions',
                      :key='item',
                      :label='item',
                      :value='item')
                      | {{ item }}
    EditModal(:displayModal.sync="dialogs.edit" :nodeId="item" :snapshotId="selectedSnapshot.id"
      :workspaceId="workspaceActiveId"
      :viewingMode="dialogs.view" @updated-node="updateTable")
    HistoryModal(:showModal.sync="dialogs.history" :history="history")
    SimplifiedEditModal(
      :showModal.sync="showModal"
      max-width='508px'
      scrollable
      headerColor="none"
      lButtonColor='#F44336'
      rButtonColor='#4CAF50'
      :lButtonTitle="$t('commonWords.no')"
      @clickLButton='showModal = false'
      showRButton
      showLButton
      :rButtonTitle="$t('commonWords.yes')"
      @clickRButton='goTo("/selecionar-versao-workspace")'
    ).radius
      template(slot='content')
        v-col
          v-row(style='justify-content: center;')
            AlertCircle
          v-row
            h2.modal-title {{ $t("simplifiedEditing.leaveEditorConfirmation") }}
            h3.modal-subtitle {{ $t("simplifiedEditing.leaveEditorConfirmationSubtitle") }}
    v-fade-transition
      v-overlay(:value="publishing")
        v-progress-circular(style="display: inline-block; width: 100%;" indeterminate size="64")
        div(style="display: inline-block; width: 100%;" class="h2 font-weight-thin") {{ $t('snapshots.publishingVersion') }}

</template>

<script>

import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import moment from 'moment'
import Modal from '@/components/Modal.vue'
import EditModal from '@/components/SimplifiedChatbuilder/EditModal.vue'
import DateInterval from '@/components/DateInterval.vue'
import PublishIcon from '@/assets/img/publish.svg'
import SimplifiedEditModal from '@/components/SimplifiedChatbuilder/SimplifiedEditModal.vue'
import AlertCircle from '@/assets/img/alert-circle.svg'
import HistoryModal from '@/components/SimplifiedChatbuilder/HistoryModal.vue'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import debounce from 'lodash.debounce'

export default {
  name: 'SimplifiedEditingTable',
  components: {
    HistoryModal,
    AlertCircle,
    SimplifiedEditModal,
    EditModal,
    Modal,
    DataTable,
    DataProvider,
    DateInterval,
    PublishIcon
  },
  data () {
    return {
      searchQuery: '',
      mode: 'edit', // "visualize"
      item: null,
      history: [],
      showModal: false,
      interval: null,
      dialogs: {
        edit: false,
        view: false,
        history: false
      },
      labels: [this.$t('commonWords.updatedAt'), this.$t('commonWords.updatedBy'), this.$t('search.topic'),
        this.$t('snapshots.subtopic'), this.$t('snapshots.buttonName'), this.$t('snapshots.assistantResponse'),
        this.$t('commonWords.actions')],
      filter: {
        page: 0,
        perPage: 50,
        search: null
      },
      dateInterval: {
        timestamp1: moment().subtract(1, 'month').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
        timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
      },
      publishing: false
    }
  },
  created () {
    this.mode = this.viewingMode ? 'view' : 'edit'
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('snapshots', ['viewingMode', 'hasChanges', 'selectedSnapshot']),
    ...mapGetters('selectedAssistant', ['workspaceActiveId']),
    getChipColor () {
      if (this.mode === 'edit') {
        return this.hasChanges ? '#F19D38' : '#31A44C'
      }
      return '#009CDE'
    },
    allowedToPublish () {
      return this.user?.functions?.includes('chatbuilder-publish') || this?.user?.roles === 'Administrador'
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    hasHistory (item) {
      if (item?._source?.history) {
        return item?._source?.history?.length === 0
      }
      return false
    },
    async publishSnapshot () {
      try {
        this.publishing = true
        const workspaceId = this.$store.getters['selectedAssistant/workspaceActiveId']
        await this.$store.dispatch('snapshots/publishSimplifiedEditing', {
          _id: this.selectedSnapshot.id
        })
        await this.startPulling(this.selectedSnapshot.id, workspaceId)
      } catch (error) {
        const data = error?.response?.data
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.errorPublishingWorkspace'),
          html: data?.error
        })
      }
    },
    async getSnapshots () {
      this.loading = true
      // this.loadingText = 'Buscando Snapshots...'
      const result = await this.$store.dispatch('snapshots/populate', {
        page: this.pagination.page - 1,
        perPage: this.pagination.perPage,
        searchQuery: this.searchQuery
      })
      // if (!result) this.$router.push('/workspaces')
      this.pagination.total = result.total
      this.loading = false
    },
    async startPulling (snapshotId, workspaceId) {
      try {
        this.interval = setInterval(async () => {
          await this.getModelStatusByTaskId(snapshotId, workspaceId).then(response => {
            const clearStatusLabels = ['complete', 'failed', 'published', 'skipped']
            if (clearStatusLabels.includes(response?.data?.status)) {
              this.getSnapshots()
              clearInterval(this.interval)
              this.$store.commit('snapshots/setHasChanges', false)
              this.publishing = false
              Swal.fire({
                icon: 'success',
                timer: 5000,
                title: this.$t('snapshots.workspacePublishedSuccessfully')
              })
              this.$router.push('/selecionar-versao-workspace')
            }
          })
        }, 10000)
      } catch (e) {
        clearInterval(this.interval)
        this.publishing = false
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest')
        })
      }
      this.loading = false
    },
    async getModelStatusByTaskId (snapshotId, workspaceId) {
      try {
        return this.$axios.get(`/chatbuilder/${snapshotId}/workspace/${workspaceId}/status`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest')
        })
      }
    },
    updateTable () {
      this.$refs.dataProvider.load()
      this.$refs.dataTable.fetchData()
      this.$store.commit('snapshots/setHasChanges', true)
    },
    updateFilter (dateInterval) {
      this.dateInterval = dateInterval
    },
    async handleActions (item, action) {
      this.dialogs = {
        edit: false,
        view: false,
        history: false
      }
      this.item = item._source.dialog_node
      switch (action) {
        case 'edit':
          this.dialogs.edit = true
          break
        case 'visualize':
          this.dialogs.view = true
          this.dialogs.edit = true
          break
        case 'history':
          this.history = item._source.history
          this.dialogs.history = true
          break
        default:
          break
      }
    },
    disableButton (item) {
      return item._source?.history.length === 0
    },
    mountUrlAndParamsFilter () {
      return {
        url: `${process.env.VUE_APP_BACKEND_BASE_URL}/chatbuilder/${this.workspaceActiveId}/${this.selectedSnapshot.id}`,
        filter: {
          page: this.filter.page,
          perPage: this.filter.perPage,
          search: this.filter.search,
          from: this.dateInterval.timestamp1,
          to: this.dateInterval.timestamp2
        }
      }
    },
    formatLabels (item, index) {
      switch (index) {
        case 0:
          return moment(item._source.updatedAt).format('DD/MM/YYYY HH:mm:ss')
        case 1:
          return item?.highlight?.hasOwnProperty('updatedBy.name') ? item.highlight['updatedBy.name'][0]
            : item._source.updatedBy.name ??
            '-'
        case 2:
          return item?.highlight?.hasOwnProperty('omni_context.topic') ? item?.highlight['omni_context.topic'][0]
            : item?._source?.omni_context?.topic ??
            '-'
        case 3:
          return item?.highlight?.hasOwnProperty('parentTitle') ? item?.highlight['parentTitle'][0]
            : item._source?.parentTitle ??
            '-'
        case 4:
          return item?.highlight?.hasOwnProperty('buttonName')
            ? item?.highlight['buttonName'][0]
            : item._source?.buttonName ?? '-'
        case 5:
          return item?.highlight?.hasOwnProperty('output.generic.values.text')
            ? item?.highlight['output.generic.values.text'][0]
            : item._source.output.generic[0].values[0].text ?? '-'
      }
    },
    handleSearch: debounce(function (searchText) {
      if (searchText) {
        this.$set(this.filter, 'search', searchText)
        this.searchQuery = searchText
      } else {
        this.$delete(this.filter, 'search')
      }
    }, 300),
    createHeaderPDF () {
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    goTo (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-styles {
  padding: 2px 25px 0 15px;
}
.header-rows {
  display: flex;
  justify-content: flex-end;
}

.icon-size {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.datatable {
  margin-top: 40px;
  ::v-deep table {
    table-layout: auto;
  }
  ::v-deep .md-table-head:nth-child(6) {
    width: 478px !important;
    margin-left: 10px;
  }
  .search-input {
    font-size: 14px;
    ::v-deep input::placeholder {
      font-size: 14px;
      color: #6E6E6E !important;
    }
  }
}

.breakText {
  word-break: break-all;
  overflow-wrap: break-word;
}

.modal-title {
  padding-top: 20px;
  font-size: 32px;
  line-height: 37.5px;
  font-weight: 600;
  text-align: center;
}

.modal-subtitle {
  font-size: 16px;
  line-height: 18.75px;
  text-align: center;
}

.button-rows {
  & ::v-deep i {
    margin-right: 8px;
  }

  & > button {
    margin-left: 10px;
    color: #FFFFFF;
    font-weight: 400;
    margin-bottom: 20px;
  }

}

.data-area {
  padding-left: 26px;
}

</style>
